import { Text, Container, Title, SimpleGrid, createStyles, rem, RingProgress, Flex, Group } from "@mantine/core"
import { useMediaQuery } from "@mantine/hooks"
import React from "react"

const data = [
  {
    title: "№1",
    description: "Образовательная платформа в сфере фитнеса и нутрициологии",
  },
  {
    title: "Более 40",
    description: "Обучающих курсов: профессии, навыки, образование",
  },
  {
    title: "24/7",
    description: "Учитесь с любым графиком из любой точки мира",
  },
  {
    title: "Более 15000",
    description: "Выпускников за 5 лет работы образовательного центра",
  },
]

const useStyles = createStyles((theme) => ({
  inner: {
    paddingTop: "4rem",
    paddingBottom: "4rem",

    [theme.fn.smallerThan("md")]: {
      paddingTop: "3rem",
      paddingBottom: "3rem",
    },

    [theme.fn.smallerThan("xs")]: {
      paddingTop: "1.5rem",
      paddingBottom: "1.5rem",
    },
  },

  container: {
    [theme.fn.smallerThan("md")]: {
      flexDirection: "column",
    },
  },

  ringContainer: {
    flexBasis: 480,

    [theme.fn.smallerThan("md")]: {
      flexBasis: "unset",
    },
  },

  ringTitle: {
    fontSize: rem(64),

    [theme.fn.smallerThan("sm")]: {
      fontSize: rem(34),
    },
  },

  ringText: {
    fontSize: theme.fontSizes.lg,

    [theme.fn.smallerThan("sm")]: {
      fontSize: theme.fontSizes.sm,
    },
  },

  item: {
    display: "flex",
  },

  title: {
    color: theme.colorScheme === "dark" ? theme.white : theme.black,
    fontWeight: 700,
    fontSize: rem(34),
    marginBottom: 48,
    maxWidth: 768,

    [theme.fn.smallerThan("md")]: {
      fontSize: "2.5rem",
      marginBottom: 32,
    },

    [theme.fn.smallerThan("xs")]: {
      fontSize: "2rem",
      marginBottom: 24,
    },
  },

  highlight: {
    position: "relative",
    color: theme.white,
    background: theme.fn.variant({ variant: "gradient", gradient: { from: "orange", to: "red" } }).background,
    borderRadius: theme.radius.sm,
    padding: `${rem(4)} ${rem(12)}`,
    lineHeight: rem(72),
  },
}))

export function WhyChooseUs(): React.JSX.Element {
  const { classes, theme } = useStyles()
  const matches = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)

  const items = data.map(({ description, title }, index) => (
    <div className={classes.item} key={index}>
      <Flex direction="column" gap="sm">
        <Title fw={700} size={matches ? "h2" : "h1"}>
          {title}
        </Title>

        <Text fw={500} size={matches ? "md" : "lg"}>
          {description}
        </Text>
      </Flex>
    </div>
  ))

  return (
    <Container size="xl" className={classes.inner}>
      <Flex gap="xl" className={classes.container}>
        <Flex direction="column">
          <Title className={classes.title}>
            <span className={classes.highlight}>Почему</span> выбирают образовательную платформу Body Coach
          </Title>

          <SimpleGrid
            cols={2}
            spacing={50}
            breakpoints={[ { maxWidth: "sm", cols: 1, spacing: 40 } ]}
            style={{ marginTop: 30 }}
          >
            {items}
          </SimpleGrid>
        </Flex>

        <Group className={classes.ringContainer} position="center">
          <RingProgress
            size={matches ? 288 : 480}
            thickness={20}
            roundCaps
            label={
              <Flex direction="column" align="center" justify="center" p="md">
                <Title fw={700} className={classes.ringTitle}>
                  97%
                </Title>
                <Text c="dimmed" fw={500} className={classes.ringText} align="center">
                  Учащихся успешно сдают домашние задания и получают образовательные документы
                </Text>
              </Flex>
            }
            sections={[ { value: 95, color: "blue" } ]}
          />
        </Group>
      </Flex>
    </Container>
  )
}
